import { formatPrice } from '@/utils';
import { TRIAL_DAYS } from '@/config';
import { CheckIcon } from '@/components/Icons';

const PLAN_DESCRIPTIONS_ICONS = Array(4).fill(CheckIcon);

export function usePlanDescriptions(monthlyPlan) {
	const baseKey = 'fastCheckout.plans.descriptions';
	const transValues = {
		monthlyPrice: formatPrice({
			amount: monthlyPlan?.baseAmount,
			currency: monthlyPlan?.currency
		}),
		trialDays: TRIAL_DAYS
	};

	return PLAN_DESCRIPTIONS_ICONS.map((Icon, index) => ({
		i18nKey: `${baseKey}.${index}`,
		Icon,
		transValues
	}));
}
